<template>
  <div class="navbar-actions">
    <!-- Language -->
    <div class="language">
      <button
        type="button"
        class="language-button"
        :class="{ active: isOpen }"
        :aria-expanded="isOpen"
        aria-label="Pilih bahasa"
        @click="toggleLanguage"
      >
        <!-- Globe Icon -->
        <svg
          class="language-icon"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <circle
            cx="12"
            cy="12"
            r="9"
            stroke="currentColor"
            stroke-width="1.7"
          />

          <path
            d="M3 12H21"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
          />

          <path
            d="M12 3C14.2 5.4 15.3 8.4 15.3 12C15.3 15.6 14.2 18.6 12 21"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
          />

          <path
            d="M12 3C9.8 5.4 8.7 8.4 8.7 12C8.7 15.6 9.8 18.6 12 21"
            stroke="currentColor"
            stroke-width="1.7"
            stroke-linecap="round"
          />
        </svg>

        <!-- Current Language -->
        <span class="language-current">
          {{ currentLanguage }}
        </span>

        <!-- Chevron -->
        <svg
          class="language-chevron"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M7 10L12 15L17 10"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>

      <!-- Dropdown -->
      <Transition name="language-dropdown">
        <div
          v-if="isOpen"
          class="language-dropdown"
        >
          <!-- Indonesia -->
          <button
            type="button"
            class="language-option"
            :class="{ active: currentLanguage === 'ID' }"
            :aria-current="currentLanguage === 'ID' ? 'true' : undefined"
            @click="selectLanguage('id')"
          >
            <span class="language-option-text">
              Indonesia
            </span>

            <svg
              v-if="currentLanguage === 'ID'"
              class="language-check"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M5 12.5L9.5 17L19 7"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>

          <!-- English -->
          <button
            type="button"
            class="language-option"
            :class="{ active: currentLanguage === 'EN' }"
            :aria-current="currentLanguage === 'EN' ? 'true' : undefined"
            @click="selectLanguage('en')"
          >
            <span class="language-option-text">
              English
            </span>

            <svg
              v-if="currentLanguage === 'EN'"
              class="language-check"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              aria-hidden="true"
            >
              <path
                d="M5 12.5L9.5 17L19 7"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
          </button>
        </div>
      </Transition>
    </div>

    <!-- Login -->
    <BaseButton
      to="/login"
      variant="primary"
      class="navbar-login"
    >
      {{ $t('navbar.login') }}
    </BaseButton>
  </div>
</template>

<script>
import BaseButton from '@/components/common/Button.vue'

export default {
  name: 'NavbarActions',

  components: {
    BaseButton
  },

  data() {
    return {
      isOpen: false
    }
  },

  computed: {
    currentLanguage() {
      return this.$i18n.locale.toUpperCase()
    }
  },

  methods: {
    toggleLanguage() {
      this.isOpen = !this.isOpen
    },

    selectLanguage(language) {
      if (!['id', 'en'].includes(language)) return

      // Tidak melakukan apa pun jika bahasa sudah dipilih
      if (this.$i18n.locale === language) {
        this.isOpen = false
        return
      }

      // Ganti bahasa secara reaktif tanpa reload
      this.$i18n.locale = language

      // Simpan pilihan bahasa untuk kunjungan berikutnya
      localStorage.setItem('language', language)

      // Tutup dropdown
      this.isOpen = false
    }
  }
}
</script>